import { render, staticRenderFns } from "./TextMessage.vue?vue&type=template&id=74b3673b&scoped=true&"
import script from "./TextMessage.vue?vue&type=script&lang=js&"
export * from "./TextMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b3673b",
  null
  
)

export default component.exports